import React from 'react';
import PageMetaEditPopup from './meta_section_edit';
import {connect} from 'react-redux';
import {comparer} from '../../../../components/helpers/helpers';
import {closeMetaSection, updatePageMetaSection} from '../../actions';
import {fetchImageRatios} from '../../../images/thunks';
import {showErrMsgPopup} from '../../../../components/helpers/helpers';
import {
    addLocation,
    deleteHeroImageField,
    deleteReviewImageField,
    removeLocation,
    setSelectedLocations,
    updateAccommodationsField,
    updateAdditionalRequirementsField,
    updateSnippetSortOrderField,
    updateSnippetAttributeField,
    updateIsTravelProduct,
    updateDatesField,
    updateHeroCroppedImage,
    updateHeroImageField,
    updateHeroImageMeta,
    updateHeroThumbCroppedImage,
    updateHeroVideoUrlField,
    updatePageBreadcrumbTitleField,
    updatePageMenuTitleField,
    updatePageMetaDescriptionField,
    updatePageMetaTitleField,
    updatePageMetaReviewAbbrName,
    updatePageMetaReviewAgeGroup,
    updatePageMetaReviewFullName,
    updatePageMetaReviewLanguage,
    updatePageMetaReviewProducts,
    updatePageMetaLandingProducts,
    updatePageMetaReviewQuote,
    updatePageMetaBlogAuthor,
    updatePageMetaBlogDate,
    updatePageOldUrlField,
    updatePageSubheadingField,
    updatePageTitleField,
    updateRequirementsField,
    updateSnippetField,
    updateReviewCroppedImage,
    updateReviewImageMeta,
    updateReviewThumbCroppedImage,
    updateReviewImageField,
    updatePageMetaTeam,
} from '../../meta/actions';

class MetaPopup extends React.Component {
    handleLocationsChange = (selectedOptions) => {
        let previousLocations = this.props.locations;
        let selectedLocations = selectedOptions;

        // removed one from selectedLocations
        if (previousLocations.length > selectedLocations.length) {
            let onlyInA = previousLocations.filter(comparer(selectedLocations));
            let location = onlyInA[0];
            this.props.removeLocation(location);
        }

        // added one to selectedLocations
        if (previousLocations.length < selectedLocations.length) {
            let onlyInB = selectedLocations.filter(comparer(previousLocations));
            let location = onlyInB[0];
            this.props.addLocation(location);
        }

        this.props.setSelectedLocations(selectedOptions);
    };

    componentDidMount() {
        if (this.props.metaEditOpen === true) {
            this.props.fetchImageRatios();
        }
    }

    render() {
        return (
            <PageMetaEditPopup
                open={this.props.metaEditOpen}
                title={this.props.title}
                subheading={this.props.subheading}
                oldUrl={this.props.oldUrl}
                breadcrumbTitle={this.props.breadcrumbTitle}
                menuTitle={this.props.menuTitle}
                snippet={this.props.snippet}
                heroImage={this.props.heroImage}
                heroVideoUrl={this.props.heroVideoUrl}
                updateHeroVideoUrlField={this.props.updateHeroVideoUrlField}
                metaTitle={this.props.meta_title}
                metaDescription={this.props.meta_description}
                page={this.props.page}
                loading={this.props.loading}
                imageRatiosHero={this.props.imageRatios.hero}
                imageRatiosReview={this.props.imageRatios.review}
                handleLocationsChange={this.handleLocationsChange}
                updateMetaDescriptionField={this.props.updateMetaDescriptionField}
                updateMetaTitleField={this.props.updateMetaTitleField}
                updateTitleField={this.props.updateTitleField}
                updateSubheadingField={this.props.updateSubheadingField}
                updateOldUrlField={this.props.updateOldUrlField}
                updateBreadcrumbTitleField={this.props.updateBreadcrumbTitleField}
                updateMenuTitleField={this.props.updateMenuTitleField}
                updateSnippetField={this.props.updateSnippetField}
                updateDatesField={this.props.updateDatesField}
                updateRequirementsField={this.props.updateRequirementsField}
                updateAccommodationsField={this.props.updateAccommodationsField}
                updateAdditionalRequirementsField={this.props.updateAdditionalRequirementsField}
                updateSnippetSortOrderField={this.props.updateSnippetSortOrderField}
                updateSnippetAttributeField={this.props.updateSnippetAttributeField}
                updateIsTravelProduct={this.props.updateIsTravelProduct}
                handleRequestClose={this.props.closeMetaSectionPopup}
                handleRequestDone={() => {
                    // Add crop alert on DONE for the review image
                    const { reviewImage, meta, pageId,
                        updatePageMetaSection, sectionLocations } = this.props;

                    const reviewImageHasCrop =
                        reviewImage &&
                        reviewImage.new &&
                        !reviewImage.deleted &&
                        reviewImage.croppedImage === null;
                    
                    if (reviewImageHasCrop) {
                        showErrMsgPopup('Cropping the Review Image is mandatory! Please click on it in order to CROP it.');
                        return;
                    }

                    const hasAutoplayHeroVideo =
                        meta.hero_video_url
                        && meta.hero_video_url.includes('autoplay=1');

                    const hasHeroImage =
                        meta.heroImage
                        && meta.heroImage.id
                        && !meta.heroImage.deleted;

                    if (hasAutoplayHeroVideo && !hasHeroImage) {
                        showErrMsgPopup('Pages with autoplaying hero videos must include a hero image as a fallback for mobile.');
                        return;
                    }

                    updatePageMetaSection(pageId, { id: pageId, ...meta }, sectionLocations);
                }}
                onUpdateHeroImageField={this.props.updateHeroImageField}
                onDeleteHeroImageField={this.props.deleteHeroImageField}
                onCropImage={(image, imageUrlBlob, imageBlobObject, index) => {
                    this.props.updateHeroCroppedImage(
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropThumbImage={this.props.updateHeroThumbCroppedImage}
                onCropReviewImage={(
                    image,
                    imageUrlBlob,
                    imageBlobObject,
                    index
                ) => {
                    this.props.updateReviewCroppedImage(
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropReviewThumbImage={this.props.updateReviewThumbCroppedImage}
                onDeleteReviewImageField={this.props.deleteReviewImageField}
                onUpdateReviewImageField={this.props.updateReviewImageField}
                onHeroImageMetaUpdate={this.props.updateHeroImageMeta}
                onReviewImageMetaUpdate={this.props.updateReviewImageMeta}
                updatePageMetaBlogAuthor={this.props.updatePageMetaBlogAuthor}
                updatePageMetaBlogDate={this.props.updatePageMetaBlogDate}
                updatePageMetaReviewFullName={this.props.updatePageMetaReviewFullName}
                updatePageMetaReviewProducts={this.props.updatePageMetaReviewProducts}
                updatePageMetaLandingProducts={this.props.updatePageMetaLandingProducts}
                updatePageMetaReviewAbbrName={this.props.updatePageMetaReviewAbbrName}
                updatePageMetaReviewQuote={this.props.updatePageMetaReviewQuote}
                updatePageMetaReviewLanguage={this.props.updatePageMetaReviewLanguage}
                updatePageMetaReviewAgeGroup={this.props.updatePageMetaReviewAgeGroup}
                updatePageMetaTeam={this.props.updatePageMetaTeam}
                authorFullName={this.props.authorFullName}
                authorAbbreviatedName={this.props.authorAbbreviatedName}
                quote={this.props.quote}
                language={this.props.language}
                ageGroup={this.props.ageGroup}
                reviewImage={this.props.reviewImage}
                projects={this.props.projects}
                products={this.props.products}
            />
        );
    }
}

const mapStateToProps = state => ({
    meta: state.pageBuilderMetaPopup.data,
    metaEditOpen: state.pageBuilder.metaSectionPopup.open,
    title: state.pageBuilderMetaPopup.data.title,
    subheading: state.pageBuilderMetaPopup.data.subheading,
    oldUrl: state.pageBuilderMetaPopup.data.old_url,
    heroVideoUrl: state.pageBuilderMetaPopup.data.hero_video_url,
    breadcrumbTitle: state.pageBuilderMetaPopup.data.breadcrumb_title,
    menuTitle: state.pageBuilderMetaPopup.data.menu_title,
    snippet: state.pageBuilderMetaPopup.data.snippet,
    meta_title: state.pageBuilderMetaPopup.data.meta_title,
    meta_description: state.pageBuilderMetaPopup.data.meta_description,
    heroImage: state.pageBuilderMetaPopup.data.heroImage,
    locations: state.pageBuilderMetaPopup.data.locations,
    authorFullName: state.pageBuilderMetaPopup.data.review.author_full_name,
    authorAbbreviatedName:
        state.pageBuilderMetaPopup.data.review.author_abbreviated_name,
    quote: state.pageBuilderMetaPopup.data.review.quote,
    language: state.pageBuilderMetaPopup.data.review.language_id,
    ageGroup: state.pageBuilderMetaPopup.data.review.age_group_id,
    reviewImage: state.pageBuilderMetaPopup.data.review.image,
    products: state.pageBuilderMetaPopup.data.review.products,
    imageRatios: state.images.ratios,
    projects: state.pageBuilderMetaPopup.projects,
    sectionLocations: state.pageBuilderMetaPopup.data.sectionLocations,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(
    mapStateToProps,
    {
        updateMetaDescriptionField: updatePageMetaDescriptionField,
        updateMetaTitleField: updatePageMetaTitleField,
        updateTitleField: updatePageTitleField,
        updateSubheadingField: updatePageSubheadingField,
        updateOldUrlField: updatePageOldUrlField,
        updateBreadcrumbTitleField: updatePageBreadcrumbTitleField,
        updateMenuTitleField: updatePageMenuTitleField,
        updateSnippetField: updateSnippetField,
        updateDatesField: updateDatesField,
        updateRequirementsField: updateRequirementsField,
        updateAccommodationsField: updateAccommodationsField,
        updateAdditionalRequirementsField: updateAdditionalRequirementsField,
        updateSnippetSortOrderField: updateSnippetSortOrderField,
        updateSnippetAttributeField: updateSnippetAttributeField,
        updateIsTravelProduct: updateIsTravelProduct,
        updateHeroCroppedImage: updateHeroCroppedImage,
        updateHeroThumbCroppedImage: updateHeroThumbCroppedImage,
        updateReviewCroppedImage: updateReviewCroppedImage,
        updateReviewThumbCroppedImage: updateReviewThumbCroppedImage,
        updateHeroImageMeta: updateHeroImageMeta,
        updateReviewImageMeta: updateReviewImageMeta,
        updateHeroImageField: updateHeroImageField,
        deleteHeroImageField: deleteHeroImageField,
        deleteReviewImageField: deleteReviewImageField,
        updateReviewImageField: updateReviewImageField,
        closeMetaSectionPopup: closeMetaSection,
        updatePageMetaSection: updatePageMetaSection,
        updatePageMetaReviewFullName: updatePageMetaReviewFullName,
        updatePageMetaReviewProducts: updatePageMetaReviewProducts,
        updatePageMetaLandingProducts: updatePageMetaLandingProducts,
        updatePageMetaReviewAbbrName: updatePageMetaReviewAbbrName,
        updatePageMetaReviewQuote: updatePageMetaReviewQuote,
        updatePageMetaReviewLanguage: updatePageMetaReviewLanguage,
        updatePageMetaReviewAgeGroup: updatePageMetaReviewAgeGroup,
        updatePageMetaTeam: updatePageMetaTeam,
        updatePageMetaBlogAuthor: updatePageMetaBlogAuthor,
        updatePageMetaBlogDate: updatePageMetaBlogDate,
        setSelectedLocations: setSelectedLocations,
        addLocation: addLocation,
        removeLocation: removeLocation,
        updateHeroVideoUrlField: updateHeroVideoUrlField,
        fetchImageRatios,
    }
)(MetaPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/meta_popup.js